export const getinformed = {
  heading: "Get informed when we launch!",
};

export const subscribecard = {
  heading:
    "Stay on top of industry trends and new offers with our weekly newsletter. ",
};
